export default {
  form: {
    header: {
      label: 'Titlu',
      placeholder: 'Titlu',
    },
    sub_header: {
      label: 'Subtitlu',
      placeholder: 'Subtitlu',
    },
    qr_code_header: {
      label: 'Titlu casetă UI',
      placeholder: 'Titlu casetă UI',
    },
    qr_code_description: {
      label: 'Descriere casetă UI',
      placeholder: 'Descriere casetă UI',
    },
    footer: {
      label: 'Text subsol',
      placeholder: 'Introduceți textul subsolului',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selectați URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Culoare primară',
    },
    background_color: {
      label: 'Culoare fundal',
    },
    cover_image: {
      label: 'Imagine copertă',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea flyerului',
  },
};
